import GetsDirect from "../../api-calls/GetsDirect";
import DeleteAPI from "../../api-calls/Delete";
import { setUserInfo } from "../../features/states/slices";
import { store } from "../../app/store";

let pendingUserInfoRequest = null;

async function requestUserInfo() {
    if (!pendingUserInfoRequest) {
        pendingUserInfoRequest = GetsDirect("User/GetUserInfo")
            .then((response) => response.data)
            .finally(() => {
                pendingUserInfoRequest = null;
            });
    }

    return pendingUserInfoRequest;
}

export async function fetchUserInfo({ syncUserInfo = true } = {}) {
    const response = await requestUserInfo();
    if (syncUserInfo) {
        store.dispatch(setUserInfo(response));
    }
    return response;
}

export async function fetchSubscriptionInfo() {
    const response = await GetsDirect("Subscription/get-subscription-info");
    return response;
}

export async function fetchEnterpriseUserInfo() {
    const response = await GetsDirect("SeatAllocation/get-allocated-seats");
    return response.data;
}

export async function unassignEnterpriseSeat(user) {
    const response = await DeleteAPI(user, "SeatAllocation/deallocate-seat");
    return response.data;
}
